import React, { ReactNode, useState } from 'react';
import IconChevronBottom from 'src/assets/images/chevron-bottom.svg?react';

interface AccordionItemProps {
  title: ReactNode;
  content: ReactNode;
  opened?: boolean;
  icon?: ReactNode;
}

export const UIAccordionItem: React.FC<AccordionItemProps> = ({ title, content, icon, opened }) => {
  const [isOpen, setIsOpen] = useState<boolean>(!!opened);

  return (
    <div className="rounded-3xl bg-[#1A1C1E]">
      <button
        className={'w-full p-6 text-left focus:outline-none'}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center justify-between">
          <span className="text-lg font-semibold">{title}</span>

          {icon ? (
            icon
          ) : (
            <IconChevronBottom
              className={`h-6 w-6 transform transition-transform duration-300 ${
                isOpen ? 'rotate-180' : ''
              }`}
            />
          )}
        </div>
      </button>
      <div
        className={`transition-max-height overflow-hidden duration-300 ease-in-out ${
          isOpen ? 'max-h-[100%]' : 'max-h-0'
        }`}
      >
        {content}
      </div>
    </div>
  );
};

interface AccordionProps {
  items: AccordionItemProps[];
}

export const UIAccordion: React.FC<AccordionProps> = ({ items }) => {
  return (
    <div className="rounded-3xl">
      {items.map((item, index) => (
        <UIAccordionItem
          key={index}
          title={item.title}
          content={item.content}
          opened={item.opened}
        />
      ))}
    </div>
  );
};
